import { ICanvasPack } from "./ICanvasPack";

export abstract class BaseCanvasPack implements ICanvasPack {
  /**
   * Default implementation: draw default gradient background
   */
  drawBackground(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number,
    level?: number
  ): void {
    // Default radial gradient background (simulating the CSS one)
    const gradient1 = context.createRadialGradient(width * 0.2, height * 0.3, 0, width * 0.2, height * 0.3, width * 0.6);
    gradient1.addColorStop(0, "rgba(255, 125, 0, 0.3)");
    gradient1.addColorStop(0.3, "rgba(255, 125, 0, 0.1)");
    gradient1.addColorStop(0.6, "transparent");
    
    const gradient2 = context.createRadialGradient(width * 0.8, height * 0.4, 0, width * 0.8, height * 0.4, width * 0.6);
    gradient2.addColorStop(0, "rgba(0, 225, 255, 0.3)");
    gradient2.addColorStop(0.3, "rgba(0, 225, 255, 0.1)");
    gradient2.addColorStop(0.6, "transparent");

    // Base fill
    context.fillStyle = "#1e2742"; // var(--bg-primary)
    context.fillRect(0, 0, width, height);

    // Draw gradients
    context.fillStyle = gradient1;
    context.fillRect(0, 0, width, height);
    context.fillStyle = gradient2;
    context.fillRect(0, 0, width, height);
  }

  abstract drawFrame(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void;

  /**
   * Default implementation: draw nothing on overlay
   */
  drawOverlay(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {
    // No-op by default
  }

  /**
   * Gets the border style for the canvas element (CSS)
   * Default implementation matches current game.css
   */
  getBorderStyle(): string {
    return "2px solid var(--border-color)";
  }

  /**
   * Gets the box shadow style for the canvas element (CSS)
   * Default implementation matches current game.css
   */
  getBoxShadow(frameTime?: number): string {
    return `
      var(--shadow-lg),
      0 0 40px rgba(255, 215, 0, 0.1)
    `.trim();
  }

  /**
   * Gets the backdrop filter style for the canvas element (CSS)
   * Default implementation matches current game.css
   */
  getBackdropFilter(): string {
    return "blur(10px)";
  }
}
